import { render, staticRenderFns } from "./service-maintenance.vue?vue&type=template&id=67d8c14b&scoped=true"
import script from "./service-maintenance.vue?vue&type=script&lang=js"
export * from "./service-maintenance.vue?vue&type=script&lang=js"
import style0 from "./service-maintenance.vue?vue&type=style&index=0&id=67d8c14b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d8c14b",
  null
  
)

export default component.exports